import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function CoverSlide() {
  return <div className="flex w-screen h-screen overflow-hidden bg-white text-[#1a1a2e]" data-id="element-194">
      {/* Left Panel - 40% */}
      <div className="w-[40%] h-full flex flex-col justify-between px-16 py-12 z-10 relative shrink-0" data-id="element-195">
        {/* Top: Logo */}
        <div data-id="element-196">
          <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2 Logo" className="h-12 w-auto object-contain" data-id="element-197" />
        </div>

        {/* Middle: Title & Subtitle */}
        <div className="flex flex-col gap-6 -mt-12" data-id="element-198">
          <h1 className="text-[3.25rem] font-bold leading-[1.1] tracking-tight" data-id="element-199">
            <span className="block text-[#1a1a2e]" data-id="element-200">National Delivery</span>
            <span className="block text-[#1a1a2e]" data-id="element-201">Monitoring Platform</span>
          </h1>
          <p className="text-[1.125rem] text-[#1a1a2e]/50 max-w-[90%] leading-relaxed font-light" data-id="element-202">
            A National Platform for Full Visibility & Control of Delivery
            Operations
          </p>
        </div>

        {/* Bottom: Tagline */}
        <div className="flex items-start gap-3 text-[#1a1a2e]/40" data-id="element-203">
          <ShieldCheck className="w-5 h-5 text-[#2EBCB0] shrink-0 mt-0.5" strokeWidth={1.5} data-id="element-204" />
          <p className="text-[0.875rem] max-w-[85%] leading-snug font-medium" data-id="element-205">
            Designed to support regulatory authorities, operators, and public
            safety
          </p>
        </div>
      </div>

      {/* Right Panel - 60% */}
      <div className="w-[60%] h-full relative grow" data-id="element-206">
        {/* Gradient blend from left panel to image */}
        <div className="absolute inset-y-0 left-0 w-64 bg-gradient-to-r from-white via-white/80 to-transparent z-10 pointer-events-none" data-id="element-207"></div>

        {/* Main Cover Image */}
        <img src="https://cdn.magicpatterns.com/uploads/w7NVwgga5VKeoTutXMTgMV/ChatGPT_Image_Mar_30,_2026,_12_33_51_AM.png" alt="Dubai Delivery Ecosystem" className="w-full h-full object-cover object-center" data-id="element-208" />

        {/* Subtle Network/Connection Overlay */}
        <div className="absolute inset-0 z-10 pointer-events-none opacity-[0.12]" data-id="element-209">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-210">
            <defs data-id="element-211">
              <pattern id="network-pattern" x="0" y="0" width="400" height="400" patternUnits="userSpaceOnUse" data-id="element-212">
                {/* Nodes */}
                <circle cx="50" cy="50" r="2" fill="#2EBCB0" className="animate-pulse" data-id="element-213" />
                <circle cx="250" cy="120" r="3" fill="#2EBCB0" data-id="element-214" />
                <circle cx="120" cy="280" r="1.5" fill="#2EBCB0" data-id="element-215" />
                <circle cx="350" cy="320" r="2.5" fill="#2EBCB0" className="animate-pulse" data-id="element-216" />
                <circle cx="180" cy="180" r="1" fill="#2EBCB0" data-id="element-217" />

                {/* Connections */}
                <path d="M50 50 L250 120" stroke="#2EBCB0" strokeWidth="0.5" fill="none" opacity="0.5" data-id="element-218" />
                <path d="M250 120 L350 320" stroke="#2EBCB0" strokeWidth="0.5" fill="none" opacity="0.3" data-id="element-219" />
                <path d="M50 50 L120 280" stroke="#2EBCB0" strokeWidth="0.5" fill="none" opacity="0.4" data-id="element-220" />
                <path d="M120 280 L180 180" stroke="#2EBCB0" strokeWidth="0.5" fill="none" opacity="0.6" data-id="element-221" />
                <path d="M180 180 L250 120" stroke="#2EBCB0" strokeWidth="0.5" fill="none" opacity="0.5" data-id="element-222" />
                <path d="M180 180 L350 320" stroke="#2EBCB0" strokeWidth="0.5" fill="none" opacity="0.2" data-id="element-223" />

                {/* Lines extending out of pattern bounds for continuity */}
                <path d="M50 50 L-50 -20" stroke="#2EBCB0" strokeWidth="0.5" fill="none" opacity="0.3" data-id="element-224" />
                <path d="M350 320 L450 400" stroke="#2EBCB0" strokeWidth="0.5" fill="none" opacity="0.3" data-id="element-225" />
                <path d="M120 280 L-20 350" stroke="#2EBCB0" strokeWidth="0.5" fill="none" opacity="0.3" data-id="element-226" />
              </pattern>
            </defs>
            <rect x="0" y="0" width="100%" height="100%" fill="url(#network-pattern)" data-id="element-227" />
          </svg>
        </div>
      </div>
    </div>;
}